import React from "react";

const FormHelperText = ({ text }) => {
  return <small className="text-[#f85359]">{text}</small>;
};

export default FormHelperText;
